// extracted by mini-css-extract-plugin
export var standaloneTable = "_2h-0";
export var standaloneTableWithBodyFill = "_2h-1";
export var withExtraHeader = "_2h-2";